import { api } from '.';
import { query_params } from '../helpers/api'
import { Sample } from '../types'

export const getCapabilityMetrics = (filter:any) : Promise<Array<Sample>> => {
  return api.get(`/spec/capability-metric${query_params(filter)}`).then((response: any) => response.data);
};